import Vue from 'vue'

import _Doubts from './Doubts'

export const Doubts = Vue.component('doubts', _Doubts);

